import React from 'react'
import Banner from '../components/Banner';
import CoinsTable from '../components/CoinsTable';

const HomePage = () => {
  return <>
  <Banner />
  <CoinsTable></CoinsTable>
  </>;
}

export default HomePage
